import React from "react";
import { Button } from "flowbite-react";

interface CTAProps {
    title: string;
    text: string;
    url: string;
}

interface PromotionalPanelProps {
    title: string;
    imageUrl: string;
    cta: CTAProps;
    footerBgColor?: string;
}

const PromotionalPanel: React.FC<PromotionalPanelProps> = ({ title, imageUrl, cta, footerBgColor = "bg-gray-800" }) => {
    return (
        <>
            {/* Desktop View */}
            <div className='relative flex-1 hidden h-full text-white lg:flex flex-col'>
                <div className='pl-16 pr-32 py-32'>
                    <h1 className='text-6xl font-semibold leading-relaxed'>{title}</h1>
                </div>

                <img
                    alt={""}
                    loading='lazy'
                    srcSet={imageUrl}
                    className='absolute h-full w-full object-cover object-center inset-0 rounded-3xl -z-10'
                />
                <div className={`flex flex-row items-center justify-between mt-auto px-16 py-5 ${footerBgColor} rounded-b-3xl`}>
                    <span className='text-lg'>{cta.title}</span>
                    <Button
                        href={cta.url}
                        className='bg-purple-600 hover:bg-purple-700 text-white py-1 px-4 rounded-lg border-none'>
                        {cta.text}
                    </Button>
                </div>
            </div>

            {/* Mobile View */}
            <div className='w-full relative text-white flex lg:hidden flex-col'>
                <img
                    alt={""}
                    loading='lazy'
                    srcSet={imageUrl}
                    className='absolute h-[110dvh] w-full object-cover object-center top-12 inset-0 -z-10'
                />
                <div className={`flex flex-row items-center justify-between gap-4 px-4 py-4 ${footerBgColor} rounded-b-3xl`}>
                    <span className='text-base w-1/2'>{cta.title}</span>
                    <Button
                        href={cta.url}
                        className='bg-purple-600 hover:bg-purple-700 w-1/4 text-white py-1 rounded-lg border-none'>
                        {cta.text}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default PromotionalPanel;